import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { getFlowKey } from '../routing/getFlowKey';
import { isSoftwareSignup } from '../store/flow/selectors';
import { Step } from '../views/Step';
import { getLandingPageTitle } from './getLandingPageText';
import { getIntegrationName } from '../utils/getIntegrationName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import styled from 'styled-components';
import { H1 } from 'UIComponents/elements/headings';
import { Flow } from 'signup-constants/Flow';
import { devices } from '../styles/viewports.styles';
export const StyledH1 = styled(H1).withConfig({
  displayName: "renderLandingPageTitle__StyledH1",
  componentId: "sc-1hloqo1-0"
})(["margin-top:40px;font-size:2.25rem;", " ", " @media ", "{", "}@media ", "{margin-top:", ";}"], props => (props.flowKey === Flow.Connect || props.flowKey === Flow.ChatSpot) && `font-size: 1.75rem;`, props => props.theme.embedded && ` margin-top: 0;
      font-size: 1.75rem;`, devices.tablet, props => props.isFramedCentredStep && ` margin-top: 0;`, devices.desktop, props => props.isFramedCentredStep ? '20px' : '0');
export const LandingPageSubtitle = styled.div.withConfig({
  displayName: "renderLandingPageTitle__LandingPageSubtitle",
  componentId: "sc-1hloqo1-1"
})(["", ""], props => props.theme.embedded && `margin-bottom: 1rem;`);
export const renderLandingPageTitle = ({
  isMobile,
  isFramedCentredStep = false
}) => {
  const flowKey = getFlowKey();
  const {
    title,
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const defaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
  const subtitle = isMobile && isSoftwareSignup() ? defaultMobileSubtitle : subtitleLabel;
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center m-x-auto flex-column justify-center",
    children: [/*#__PURE__*/_jsx(StyledH1, {
      flowKey: flowKey,
      isFramedCentredStep: isFramedCentredStep,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title,
        options: {
          integratorName: getIntegrationName()
        }
      })
    }), /*#__PURE__*/_jsx(LandingPageSubtitle, {
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: subtitle
      })
    })]
  });
};